import { API_BASE, buildQuery, request } from './api-client';
import type {
  AdminCreditPackRow,
  CreateCreditPackInput,
  EditCreditPackInput,
  RepriceCreditPackInput,
  SetCreditPackOfferInput,
} from '../types/credit-pack.types';

const BASE = `${API_BASE}/admin/credit-packs`;

export function listCreditPacks(isActive?: boolean) {
  const query = isActive !== undefined ? { isActive } : {};
  return request<AdminCreditPackRow[]>(`${BASE}${buildQuery(query)}`);
}

export function getCreditPack(id: string) {
  return request<AdminCreditPackRow>(`${BASE}/${id}`);
}

export function createCreditPack(input: CreateCreditPackInput) {
  return request<AdminCreditPackRow>(BASE, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function editCreditPack(id: string, input: EditCreditPackInput) {
  return request<AdminCreditPackRow>(`${BASE}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

export function repriceCreditPack(id: string, input: RepriceCreditPackInput) {
  return request<AdminCreditPackRow>(`${BASE}/${id}/reprice`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function activateCreditPack(id: string) {
  return request<AdminCreditPackRow>(`${BASE}/${id}/activate`, {
    method: 'POST',
  });
}

export function deactivateCreditPack(id: string) {
  return request<AdminCreditPackRow>(`${BASE}/${id}/deactivate`, {
    method: 'POST',
  });
}

export function setCreditPackOffer(id: string, input: SetCreditPackOfferInput) {
  return request<AdminCreditPackRow>(`${BASE}/${id}/offer`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function endCreditPackOffer(id: string) {
  return request<AdminCreditPackRow>(`${BASE}/${id}/end-offer`, {
    method: 'POST',
  });
}
